module.exports = __webpack_public_path__ + "static/media/Iconfield01.86c0cfb3.svg";